export const FILTER_TYPE_DATE_RANGE = 'date_range';
export const FILTER_TYPE_SELECT_LIST = 'select_list';
export const FILTER_TYPE_DATE_RANGE_LIST = 'date_range';
export const FILTER_TYPE_FETCH_SELECT_LIST = 'fetch_select_list';

export const DEFAULT_SEARCH_MIN_CHARS = 3;

export const TERMINATION_STATUS = [{ id: 0, value: 'pth_new' }, { id: 1, value: 'pth_in_progress' }, { id: 2, value: 'pth_done' }];